import * as React from 'react';

const CalendarIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 154 96" fill="none" {...props}>
        <path
            d="M69.768 8.295c-23.332 6.627-48.044 17.336-52.806 30.687-2.857 7.923 9.476 8.692 4.428 15.03C13.581 63.81-2.894 67.987.44 82.01c6.38 26.893 143.513 2.353 152.037-13.398 9.999-18.536-32.427-12.582-34.379-18.632-1.905-6.1 22.237-22.955 17.38-34.576-4.857-11.622-29.808-17.288-65.71-7.108z"
            fill="#D1410C"
            fillOpacity={0.08}
        />
        <path d="M46 75h62V31H46v44zM46 31h62V21H46v10z" fill="#fff" />
        <path
            clipRule="evenodd"
            d="M46 75h62V31H46v44z"
            stroke="#39364F"
            strokeWidth={2}
        />
        <path
            d="M66 44h6v-6h-6v6zM74 44h6v-6h-6v6zM82 44h6v-6h-6v6zM90 44h6v-6h-6v6zM98 44h6v-6h-6v6zM50 52h6v-6h-6v6zM58 52h6v-6h-6v6zM66 52h6v-6h-6v6zM74 52h6v-6h-6v6zM82 52h6v-6h-6v6zM90 52h6v-6h-6v6zM98 52h6v-6h-6v6zM50 60h6v-6h-6v6zM58 60h6v-6h-6v6zM66 60h6v-6h-6v6z"
            fill="#EEEDF2"
        />
        <path
            d="M74 60h6v-6h-6v6zM82 60h6v-6h-6v6zM90 60h6v-6h-6v6zM98 60h6v-6h-6v6zM50 68h6v-6h-6v6zM58 68h6v-6h-6v6zM66 68h6v-6h-6v6zM74 68h6v-6h-6v6zM82 68h6v-6h-6v6z"
            fill="#F05537"
        />
        <path d="M46 28v-7h62v7" stroke="#39364F" strokeWidth={2} />
        <path
            d="M52 25h50M62 41h-2M54 41h-2M102 65h-2M94 65h-2"
            stroke="#39364F"
            strokeWidth={2}
            strokeLinejoin="round"
        />
    </svg>
);

CalendarIllustrationSvg.displayName = 'CalendarIllustrationSvg';
export default CalendarIllustrationSvg;
